import React from 'react';
import { BiSolidBot, BiSolidChat, BiSolidMessageDetail } from 'react-icons/bi';

import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import { BiLouise } from '../AppearanceSharedAi';

const WidgetIconTypeIcon = ({ icon, size = 75, color = 'white' }: { icon: string; size?: number; color?: string }) => {
  const iconMapper: Record<string, React.ReactNode> = {
    '4': <BiLouise />,
    '1': <BiSolidBot color={color} size={size} />,
    '2': <BiSolidChat color={color} size={size} />,
    '3': <BiSolidMessageDetail color={color} size={size} />,
  };

  return iconMapper[icon];
};

export default WrappedErrorBoundary(WidgetIconTypeIcon);
